import React, { useEffect, useState, useRef  } from "react";
import AppNavbar from "../../Navbar/AppNavbar";
import Footer from "../../Navbar/Footer";
import PageBreadcome from "../../CommonFile/PageBreadcome";
import { useDispatch } from "react-redux";
import {
  getDefaultProvider,
  updateDefaultProvider,
} from "../../redux/action";
import "../../../assets/css/defaultProvider.scss";

const DefaultProvider = () => {
  const dispatch = useDispatch();
  const providerUpdateRef = useRef(false);
  const signInDetails = JSON.parse(
    sessionStorage.getItem("SignInDetails") || "[]"
  );

  const [defaultProvider, setDefaultProvider] = useState(
    sessionStorage.getItem("default_provider") || "apollo"
  );
  const [providerSaving, setProviderSaving] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadProvider = async () => {
      try {
        const provider = await dispatch(getDefaultProvider());
        if (provider) {
          setDefaultProvider(provider);
          sessionStorage.setItem("default_provider", provider);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadProvider();
  }, [dispatch]);

  const handleProviderChange = async (value) => {
    if (value === defaultProvider || providerSaving) return;

    // Only super_admin can change
    if (signInDetails[0]?.role !== "super_admin") {
      return;
    }

     // Synchronous lock prevents duplicate requests
    providerUpdateRef.current = true;

    const previous = defaultProvider;
    setDefaultProvider(value);
    setProviderSaving(true);

    try {
      await dispatch(updateDefaultProvider(value));
      sessionStorage.setItem("default_provider", value);
    } catch (err) {
      console.error("Failed to update default provider:", err);
      setDefaultProvider(previous);
      sessionStorage.setItem("default_provider", previous);
    } finally {
      providerUpdateRef.current = false;
      setProviderSaving(false);
    }
  };

  return (
    <div className="page-layout" style={{ position: "relative" }}>
      <AppNavbar />
      <div className="page-content">
        <div className="default-provider-main-page">
          <div className="default-provider-page">
            <PageBreadcome
              heading="Default Provider"
              sub_heading="Choose the primary data source for searches and enrichment."
            />

            {/* Stats */}
            <div className="dp-stats-row">
              <div className="dp-stat-card">
                <i className="bx bx-data" style={{ color: "#1257c7" }}></i>
                <div>
                  <h3>2</h3>
                  <span>Providers Available</span>
                </div>
              </div>

              <div className="dp-stat-card">
                <i className="bx bx-check-shield" style={{ color: "#10b981" }}></i>
                <div>
                  <h3>
                    {loading
                      ? "..."
                      : defaultProvider === "apollo"
                      ? "Apollo.ai"
                      : "SalesTarget.ai"}
                  </h3>
                  <span>Current Primary</span>
                </div>
              </div>

              <div className="dp-stat-card">
                <i className="bx bx-refresh" style={{ color: "#f59e0b" }}></i>
                <div>
                  <h3>Auto</h3>
                  <span>Fallback Enabled</span>
                </div>
              </div>
            </div>

            {/* Main card */}
            <div className="dp-content">
              <div className="dp-content-header">
                <div>
                  <h4>Select Primary Provider</h4>
                  <p>
                    This provider will be tried first for People Search, Company
                    Search, and Enrich / Unlock operations. If it fails, the
                    system automatically falls back to the other provider.
                  </p>
                </div>

                {providerSaving && (
                  <span className="dp-saving-badge">
                    <span className="dp-spinner"></span>
                    Saving...
                  </span>
                )}
              </div>

              {/* Provider cards */}
              <div className="dp-provider-grid">
                {/* Apollo */}
                <div
                  className={`dp-provider-card ${
                    defaultProvider === "apollo" ? "active" : ""
                  }`}
                  onClick={() => handleProviderChange("apollo")}
                >
                  <div className="dp-provider-top">
                    <div className="dp-provider-icon apollo">
                      <i className="bx bx-radar"></i>
                    </div>
                    <div className="dp-provider-radio">
                      <input
                        type="radio"
                        name="provider"
                        checked={defaultProvider === "apollo"}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleProviderChange("apollo")}
                        disabled={providerSaving}
                      />
                    </div>
                  </div>

                  <h5>Apollo.ai</h5>
                  <p className="dp-provider-desc">
                    Strong people & company database with email and phone
                    enrichment.
                  </p>
                  <ul className="dp-feature-list">
                    <li>People & company search</li>
                    <li>Email enrichment</li>
                    <li>Webhook-based phone unlock</li>
                  </ul>
                  {defaultProvider === "apollo" && (
                    <span className="dp-active-tag">Primary</span>
                  )}
                </div>

                {/* SalesTarget */}
                <div
                  className={`dp-provider-card ${
                    defaultProvider === "salestarget" ? "active" : ""
                  }`}
                  onClick={() => handleProviderChange("salestarget")}
                >
                  <div className="dp-provider-top">
                    <div className="dp-provider-icon salestarget">
                      <i className="bx bx-target-lock"></i>
                    </div>
                    <div className="dp-provider-radio">
                      <input
                        type="radio"
                        name="provider"
                        checked={defaultProvider === "salestarget"}
                        onClick={(e) => e.stopPropagation()}
                        onChange={() => handleProviderChange("salestarget")}
                        disabled={providerSaving}
                      />
                    </div>
                  </div>

                  <h5>SalesTarget.ai</h5>
                  <p className="dp-provider-desc">
                    Large global lead coverage with fast search and direct
                    unlock.
                  </p>
                  <ul className="dp-feature-list">
                    <li>Large people database</li>
                    <li>Fast search results</li>
                    <li>Direct email & phone unlock</li>
                  </ul>
                  {defaultProvider === "salestarget" && (
                    <span className="dp-active-tag">Primary</span>
                  )}
                </div>
              </div>

              <div className="dp-note">
                <i className="bx bx-info-circle"></i>
                <div>
                  <strong>Note:</strong> Changing the default provider only
                  affects new searches and enrichments. Already unlocked
                  contacts remain unchanged. If the primary provider fails, the
                  secondary provider is used automatically.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default DefaultProvider;